import { Box, Flex } from "@chakra-ui/react";
import AdminSidebar from "@root/components/adminDashboard/sidebar/adminSidebar";
import React from "react";
import { Outlet } from "react-router-dom";
import { StyledAdminLayout } from "./styles";

const AdminLayout: React.FC = () => {
  return (
    <StyledAdminLayout>
      <Flex flexDir={"column"} height={"100%"} flex={1}>
        <Flex width={"100%"} height={"100%"} overflow={"hidden"}>
          <Box height={"100%"} className="left-box">
            <AdminSidebar />
          </Box>
          <Box
            width={"100%"}
            height={"100%"}
            className="right-box"
            flex={1}
            position={"relative"}
            zIndex={1}
          >
            <Outlet />
          </Box>
        </Flex>
      </Flex>
    </StyledAdminLayout>
  );
};

export default AdminLayout;
